import { Frame } from '../../../types/types';
import { FRAME_TYPE } from '../../frame/frame.types';

/**
 * Get the margin for a frame when exporting it for upload.
 * This is used to ensure that the frame is not cut off at the edges when exporting.
 * @param frame - The frame to get the margin for.
 * @returns The margin for the frame in points
 * NOTE: // TODO : if tomorrow 1pixel is not the same as 1 point, we need to change the values here with the pixelToPoint function
 * TODO: maybe add spine also for upload margin
 */
export const getFrameUploadMargin = (frame: Frame) => {
  return frame.type === FRAME_TYPE.TEXT ? 5 : 0;
};
